<script lang="ts">
    import { Button, TabContent, TabPane } from "sveltestrap";
    import AppWraper from "../components/AppWraper.svelte";
    import RegisterCitationList from "../components/RegisterCitationList.svelte";
    import RegisterIntoOutList from "../components/RegisterIntoOutList.svelte";
    import RegisterModal from "../components/RegisterModal.svelte";
    import RegisterModalCitation from "../components/RegisterModalCitation.svelte";
    import { v4 as uuidv4 } from 'uuid';
    import { getCurrentUser } from "../services/session";

    let showDataArrested: boolean = false;
    let showDataExternal: boolean = false;
    let showDataUnidentified: boolean = false;
    let showDataCitation: boolean = false;
    let isChargeDataArrested: boolean = false;
    let isChargeDataExternal: boolean = false;
    let isChargeDataUnidentified: boolean = false;
    let isChargeDataCitation: boolean = false;

    export let newRegister = null;
    export let newRegisterCitation = null;

    async function saveRegister(){

    }

    async function saveCitacion(){

    }

    let tabSelected: string ='';

    function accessToInfo(e){
        if (e.detail == 'dataArrested') {
            showDataArrested = true;
            isChargeDataArrested = true;
        }
        if (e.detail == 'dataExternal') {
            showDataExternal = true;
            isChargeDataExternal = true;
        }
        if (e.detail == 'dataUnidentified') {
            showDataUnidentified = true;
            isChargeDataUnidentified = true;
        }
        if (e.detail == 'dataCitation') {
            showDataCitation = true;
            isChargeDataCitation = true;
        }
        tabSelected = e.detail;
    }

    function showNewRegister(){
        //Dependiendo de que tab esté seleccionado, se crea el registro de entrada/salida o citaciones, linea comentada por que da errores en el uid
        if(tabSelected =='dataInto'){
            createRegister();
        }
        else{
            createRegisterCitation();
        }
    }

    function createRegister(){
        newRegister =
            {
                id:uuidv4(),
                inRegisterNumber: null,
                inDate: null,
                origin:null,
                request:' ',
                outRegisterNumber:null,
                outDate: null,
                destination:null,
                agentId:null,
                report:' ',
                thirdId:null,
                content:null,
                contentInfo:null,
                userId:getCurrentUser().id,
                outPutLock:false,
                fileNumber:' '
            }

    }

    function createRegisterCitation(){
        newRegisterCitation =
            {
                id:uuidv4(),
                inRegistNumber: null,
                inDate: null,
                origin:null,
                request:' ',
                outRegistNumber:null,
                outDate: null,
                expedientNumber:' ',
                agentId:null,
                report:' ',
                thirdId:null,
                content:null,
                userId:getCurrentUser().id,
                outPutLock:false,
                recipientThird:uuidv4()
            }
    }

</script>

<style>

</style>

<AppWraper>

    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Registros</h3>
                    </div>
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <div class="text-end">
                        <Button color="success" on:click={() => showNewRegister()}>
                            Nuevo Registro
                        </Button>
                    </div>
                </div>
            </div>

            <TabContent on:tab={(e) => accessToInfo(e)}>
                <TabPane tabId="dataInto" tab="Entrada/Salida" active>
                    <RegisterIntoOutList />
                </TabPane>
                <TabPane tabId="dataCitation" tab="Citaciones">
                    {#if showDataCitation}
                        <RegisterCitationList on:saveCitacion={(event) => saveRegister()} />
                    {/if}
                </TabPane>
            </TabContent>
        </div>
    </div>

    <RegisterModal register={newRegister} newRegister={true} on:createRegister()={() => createRegister()}/>
    <RegisterModalCitation register={newRegisterCitation} newRegister={true} on:createRegisterCitation()={() => createRegisterCitation()}/>
</AppWraper>



